<template>
	<v-dialog
	  v-model="dialog"
	  persistent
	>
		<template v-slot:activator="{ on, attrs }">
			<slot name="activator" :makeRequest="makeRequest"></slot>
		</template>
		<v-card>
			<v-card-text>
				<div class="comment-text">{{ $t('Workflow.CommentText') }}</div>
				<v-text-field
					dense
					outlined
					hide-details
					v-model="comment"
					:label="$t('Workflow.CommentPlaceholder')"
				></v-text-field>
			</v-card-text>
			<v-card-actions>
				<v-spacer/>
				<v-btn color="success" @click="commitComment()">{{ $t('Create') }}</v-btn>
				<v-btn color="secondary" @click="dialog = false">{{ $t('Close') }}</v-btn>
			</v-card-actions>
			</v-card>
	</v-dialog>
</template>

<script>
import { fetchBasicUrlPostJson } from '@/script/common';

export default {
	props: {
		url: {
			type: String,
			required: true
		},
		requestData: {
			type: Object,
			required: true
		},
		options: {
			type: Object,
			required: false
		}
	},
    data() {
        return {
            dialog: false,
			fetchMethod: fetchBasicUrlPostJson,
			fetchSettings: {},
			fetchHandlerSettings: null,
			workflowLevel: null,
			comment: null
        };
    },
	methods: {
		setDefaults() {
			this.fetchMethod = fetchBasicUrlPostJson;
			this.fetchSettings = {};
			this.fetchHandlerSettings = null;
			this.workflowLevel = null;
			this.comment = null;
		},
		makeRequest() {
			this.setDefaults();
			if (this.options) {
				if (this.options.fetchMethod) {
					this.fetchMethod = this.options.fetchMethod;
				}
				if (this.options.fetchSettings) {
					this.fetchSettings = this.options.fetchSettings;
				}
				if (this.options.fetchHandlerSettings) {
					this.fetchHandlerSettings = this.options.fetchHandlerSettings;
				}
			}
			return this.fetchMethod(this.url, { ...this.fetchSettings, data: this.requestData }, this.fetchHandlerSettings)
				.then(resp => {
					if (resp && resp.DelayWorkflow) {
						this.sendResponse({
							delay: true,
							response: resp
						});
					}
					if (resp && resp.Level) {
						this.workflowLevel = resp.Level;
						this.dialog = true;
					} else {
						this.sendResponse({
							success: true,
							response: resp
						});
					}
				});
		},
		commitComment() {
			if (!this.comment) {
				return;
			}
			let requestData = {
				...this.requestData,
				WorkflowRequestApproved: true.toString(),
				WorkflowRequestLevel: this.workflowLevel.toString(),
				WorkflowRequestComment: this.comment
			};
			this.fetchMethod(this.url, { ...this.fetchSettings, data: requestData }, this.fetchHandlerSettings)
				.then(workflowCreateResult => {
					this.dialog = false;
					if (workflowCreateResult && workflowCreateResult.IsApproved) {
						this.sendResponse({
							success: true,
							workflowCreated: true,
							response: workflowCreateResult.OriginalResponse
						});
					} else {
						blockUI("მოთხოვნა გაგზავნილია.");
						this.sendResponse({
							success: false,
							workflowCreated: true
						});
					}
				});
		},
		sendResponse(data) {
			this.$emit('response', data);
		}
	}
}
</script>

<style scoped>
.comment-text {
	color: black;
	margin: 5px;
}
</style>